import { ClaimReferralResponseSchema, MintedReferralCodeResponseSchema, ReferralCodeResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function getReferralCode() {
    return api('/user/me/referral-code', ReferralCodeResponseSchema);
}
export function mintReferralCode() {
    return api('/user/me/referral-code', MintedReferralCodeResponseSchema, { method: 'PUT' });
}
export function claimReferral(accountId, input) {
    return api(`/accounts/${accountId}/referral`, ClaimReferralResponseSchema, {
        method: 'POST',
        body: input,
    });
}
